import { checkLabel, fmtIDR } from "../util";

export const STATUS = {
    DRAFT: ["Draf", "bg-neutral-100 text-neutral-600"],
    MISSING: ["Belum ada laporan", "bg-neutral-200 text-neutral-700"],
    SUBMITTED_FOR_VERIFICATION: ["Menunggu verifikasi", "bg-sky-50 text-sky-800"],
    NEEDS_CORRECTION: ["Perlu koreksi", "bg-rose-50 text-rose-800"],
    READY_FOR_OWNER: ["Siap disetujui Owner", "bg-emerald-50 text-emerald-800"],
    APPROVED: ["Disetujui", "bg-sage-dark text-white"],
    REOPENED: ["Dibuka ulang", "bg-amber-50 text-amber-800"],
};
const CHECK = { MATCHED: "text-emerald-700", MISMATCH: "text-rose-700" };

export function StatusPill({ status, testid }) {
    const [label, cls] = STATUS[status] || [status, "bg-neutral-100 text-neutral-600"];
    return <span data-testid={testid} className={`inline-block px-2 py-0.5 rounded-sm text-[10px] uppercase tracking-widest ${cls}`}>{label}</span>;
}

export function CheckText({ status, testid }) {
    return <span data-testid={testid} className={`text-xs font-medium ${CHECK[status] || "text-amber-700"}`}>{checkLabel(status)}</span>;
}

export function Stat({ label, value, money = true, big, testid, sub }) {
    return (
        <div className={`border rounded-sm p-3 md:p-4 ${big ? "col-span-2 md:col-span-1 bg-ink text-white border-ink" : "bg-white border-mist"}`} data-testid={testid}>
            <div className={`text-[10px] uppercase tracking-[0.2em] ${big ? "text-white/60" : "text-neutral-400"}`}>{label}</div>
            <div className={`mt-1 tabular-nums font-serif tracking-tight ${big ? "text-3xl md:text-4xl" : "text-lg md:text-xl"}`}>
                {value === null || value === undefined ? "—" : money ? fmtIDR(value) : Number(value).toLocaleString("id-ID")}
            </div>
            {sub && <div className={`text-[11px] mt-1 ${big ? "text-white/60" : "text-neutral-500"}`}>{sub}</div>}
        </div>
    );
}

export function Mini({ label, value, testid }) {
    return (
        <div className="flex justify-between gap-2 py-1.5 border-b border-mist/60 text-sm" data-testid={testid}>
            <span className="text-neutral-500">{label}</span><span className="tabular-nums">{value ?? "—"}</span>
        </div>
    );
}

export const LABELS = {
    internal_sales_idr: "Penjualan Internal", shopee_sales_idr: "Penjualan kotor Shopee", tokopedia_sales_idr: "Penjualan kotor Tokopedia",
    internal_orders: "Order Internal", shopee_orders: "Order Shopee", tokopedia_orders: "Order Tokopedia",
    internal_payment_idr: "Pembayaran Internal", shopee_payout_idr: "Dana Shopee cair", tokopedia_payout_idr: "Dana Tokopedia cair",
    shipping_received_idr: "Ongkir diterima", po_dp_idr: "Total DP PO", po_settlement_idr: "Total pelunasan PO",
    dp_idr: "DP PO", settlement_idr: "Pelunasan PO",
};
